module.exports = __webpack_public_path__ + "static/media/local-economic-dev.d3144945.png";